export default "__VITE_ASSET__2363b53f__"